import { BusinessOutlined } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';
import { WidgetHeader, WidgetIcon } from '@procureai/ui-mui';

interface SourcingProjectSupplierWidgetHeaderProps {
  title: string;
  loading?: boolean;
}

export const SourcingProjectSupplierWidgetHeader = ({ title, loading }: SourcingProjectSupplierWidgetHeaderProps) => {
  return (
    <WidgetHeader
      title={title}
      icon={<WidgetIcon icon={<BusinessOutlined fontSize="small" />} />}
      actionsLeft={loading ? <CircularProgress size={20} /> : undefined}
    />
  );
};
